import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import BarcodeScanner from './BarcodeScanner';
import { getBinByBarcode } from 'services/stock-location/binServices';
import { toast } from 'react-toastify';
import BasicTemplate from 'components/Toast/BasicTemplate';

export default function InputScanBin({
  intialValue,
  outputData,
  additionalClassName = '',
  addBtnEnabled = () => {}
}) {
  const [barcode, setBarcode] = useState(intialValue);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const debounceRef = useRef(null);

  const handleScan = barcode => {
    setBarcode(barcode);
    setIsModalOpen(false);
    debounceApiCall(barcode);
  };
  const handleChange = e => {
    const value = e.target.value;
    setBarcode(value);
    debounceApiCall(value);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const debounceApiCall = value => {
    if(!value) {
      setBarcode('');
      outputData(undefined);
      return
    }
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      getBinByBarcode(value).then(x => {
        console.log(x)
        if (x?.data?.id > 0) {
          const bin = {
            binBarcode: value,
            binId: x?.data?.id,
            location: x?.data?.locationBarcode
          };
          outputData(bin);
          addBtnEnabled(true);
        } else {
          toast.error(
            <BasicTemplate
              success={false}
              text={x?.message}
            />
          );
          outputData(undefined);
          addBtnEnabled(false);
        }
      });
    }, 500);
  };

  return (
    <>
      {isModalOpen == true && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99999999
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              position: 'relative'
            }}
          >
            <BarcodeScanner onScan={handleScan} onClose={closeModal} />
            <button
              onClick={closeModal}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              Đóng
            </button>
          </div>
        </div>
      )}

      <Form.Group
        controlId="bin"
        className={'position-relative ' + additionalClassName}
      >
        <Form.Control
          type="text"
          name="bin"
          placeholder="BIN..."
          onChange={e => handleChange(e)}
          className="pe-5  w-100"
          style={{ height: '38px' }}
          value={barcode}
        />

        <FontAwesomeIcon
          icon={faCamera}
          onClick={openModal}
          className="position-absolute top-50 end-0 translate-middle-y me-3 text-secondary"
          style={{ fontSize: '20px', cursor: 'pointer' }}
        />
      </Form.Group>
    </>
  );
}

InputScanBin.propTypes = {
  addBtnEnabled: PropTypes.func,
  isShowHeader: PropTypes.bool,
  intialValue: PropTypes.object,
  outputData: PropTypes.func,
  additionalClassName: PropTypes.string
};
